import { Alert, useMediaQuery } from '@bi-digital/react';
import { useProductPageContext } from '../../../context/ProductPageContext';
import ProgrammeInformation from '../ProgrammeInformation/ProgrammeInformation';
import { Apply } from '../Apply/Apply';
import { ProgrammeNavigation } from '../ProgrammeNavigation/ProgrammeNavigation';
import styles from './StudySelector.module.css';

export default function StudySelector() {
    const isLargeScreen = useMediaQuery('(width >= 1128px)');

    const { programme } = useProductPageContext();

    return (
        <div className={styles.container}>
            <ProgrammeInformation programme={programme} />

            {programme.applicationAlertMessage && (
                <div className={styles.alertContainer}>
                    <Alert size='large' data-color='warning'>
                        {programme.applicationAlertMessage}
                    </Alert>
                </div>
            )}

            <section className={styles.showOptionsContainer}>
                <Apply size={isLargeScreen ? 'large' : 'medium'} />
            </section>

            <ProgrammeNavigation programmeName={programme.name}>
                <Apply size='small' />
            </ProgrammeNavigation>
        </div>
    );
}
